import { render, staticRenderFns } from "./AccessTokens.vue?vue&type=template&id=6c6a0981&"
import script from "./AccessTokens.vue?vue&type=script&lang=js&"
export * from "./AccessTokens.vue?vue&type=script&lang=js&"
import style0 from "./AccessTokens.vue?vue&type=style&index=0&id=6c6a0981&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports